export default {
  forgotPassword: "Forgot Password",
  emailAddress: "Email address",
  signIn: "Sign in",
  resetPassword: "Reset Password",
  justRemembered: "Just remembered?",
};
